import { lazy, Suspense, useRef, useEffect } from 'react';
import { Box } from '@mui/material';
import CardLoading from './CardLoading';
import { useLinesStore, getLinhasSelecionadasEfetivas } from '../stores/useLinesStore';
import { useClientsStore } from '../stores/useClientsStore';
import { useAuthStore } from '../stores/useAuthStore';
import { useLoadingStore } from '../stores/useLoadingStore';
import { useLayoutStore } from '../hooks/screen/useLayoutStore';
import { useScreenStore } from '../stores/useScreenStore';
import { useOperationalMapStore } from '../stores/useOperationalMapStore';

const TripCard = lazy(() => import('./TripCard'));

const TripCardsView = ({ trips, endOfListRef, resetScrollKey }) => {
  
  const containerRef = useRef(null);

  const loadingTrips = useLoadingStore(state => state.loading);

  const isCompactMode = useLayoutStore(
    state => state.isCompactMode
  );

  const monitorMode = useScreenStore(state => state.monitorMode);

  const isOperationalMapMode = useOperationalMapStore(state => state.isOperationalMapMode);
  
  useEffect(() => {

    containerRef.current?.scrollTo({
      top: 0,
      behavior: 'auto'
    });

  }, [resetScrollKey]);

  if(loadingTrips){
    
    const linesState = useLinesStore.getState();

    const linhasSelecionadas =
      getLinhasSelecionadasEfetivas({
          linhasDisponiveis:
              linesState.linhasDisponiveis,
  
          linhasSelecionadas:
              linesState.linhasSelecionadas,
  
          allowClientes:
              useClientsStore.getState().allowClientes,
  
          allowPerfis:
              useAuthStore.getState().allowPerfis,
  
          sentidosSet:
              linesState.sentidosSet
      });
    
      return(
        <Box
          data-compact-scroll-ignore
          ref={containerRef}
          sx={{
            flex: 1,
            overflow: 'auto',
            p: 4,
            pl: (monitorMode === 1 && (isCompactMode && !isOperationalMapMode)) ? 10 : 4
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 2
            }}
          >
            {linhasSelecionadas.length > 0 && (
              <>
                <CardLoading/>
                {linhasSelecionadas.length > 1 &&(
                  <CardLoading/>
                )}
              </>
            )}
          </Box>
        </Box>
      )
  }

  return (
    <Box
      data-compact-scroll-ignore
      ref={containerRef}
      sx={{
        flex: 1,
        overflow: 'auto',
        p: 4,
        pl: (monitorMode === 1 && (isCompactMode && !isOperationalMapMode)) ? 10 : 4
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2
        }}
      >
        {trips.map(trip => (
          <Suspense
            key={`${trip.CODIGO_INTEGRACAO}-${trip.VIAGEM_ID || ''}`}
            fallback={<CardLoading />}
          >
            <TripCard trip={trip}/>
          </Suspense>
        ))}

        <div
          ref={endOfListRef}
          style={{ height: 10 }}
        />
      </Box>
    </Box>
  );
};

export default TripCardsView;